module.exports = __webpack_public_path__ + "img/muro.373c4c66.jpg";